import InfoOutlineIcon from '@mui/icons-material/InfoOutline'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/ButtonBase'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import IconButton from '@mui/material/IconButton'
import { InputProps } from '@mui/material/Input'
import InputAdornment from '@mui/material/InputAdornment'
import Typography from '@mui/material/Typography'
import { ReactNode, useState } from 'react'

import { InputBase } from './Input.styles'

export function Input({
  label,
  startIcon,
  helperText,
  displayHelpIcon = false,
  ...props
}: { label: string; helperText?: string; startIcon?: ReactNode; displayHelpIcon?: boolean } & InputProps) {
  const theme = useTheme()

  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => setShowPassword((show) => !show)

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return (
    <Box display="flex" flexDirection="column" gap={theme.spacing.XS}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="caption">{label}</Typography>
        {displayHelpIcon && (
          <Button disableRipple>
            <InfoOutlineIcon fontSize="small" />
          </Button>
        )}
      </Box>
      <FormControl variant="outlined">
        <InputBase
          {...props}
          startAdornment={startIcon && <InputAdornment position="start">{startIcon}</InputAdornment>}
          type={showPassword ? 'text' : props.type}
          placeholder={props.placeholder}
          endAdornment={
            props.type === 'password' && (
              <InputAdornment position="end">
                <IconButton
                  aria-label={showPassword ? 'hide the password' : 'display the password'}
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            )
          }
        />
        <FormHelperText sx={{ marginLeft: 0, minHeight: '20px' }}>
          <Typography
            color={
              props.disabled
                ? theme.palette.text.disabled
                : props.error
                  ? theme.palette.error.main
                  : theme.palette.text.main
            }
            variant="caption"
          >
            {helperText ? helperText : ' '}
          </Typography>
        </FormHelperText>
      </FormControl>
    </Box>
  )
}
